// extracted by mini-css-extract-plugin
export default {"image":"PersonalImage_image__NpDHI","frame":"PersonalImage_frame__AOafI","light":"PersonalImage_light__mLWHW","dark":"PersonalImage_dark__hfA4v"};